import { MenuItem } from '../../stores/Menu/types';

export const isMiddleStateOfToggle = (items: MenuItem[]) =>
  items.some(el => !!el.subsidized) && items.some(el => !el.subsidized);

export const isAllMenuItemsSubsidized = (items: MenuItem[]) =>
  !!items?.length && items.every(el => !!el.subsidized);
